/**
 * This is part of the new Rider Funnel experience
 */
SC.forgotPassword = (function () {
  var api = {};

  var init = function () {
    if (!$('body').hasClass('new_rider_forgot_password')) {
      return;
    }

    initializeLogin();
  };

  var initializeLogin = function () {
    var $forgotPasswordForm = $('form.forgot-password__form');
    var $resetPasswordButton = $('#handle-reset-password');
    var $formError = $('.global-form__error');

    $forgotPasswordForm.on('submit', function (e) {
      e.preventDefault();
      resetPassword();
    });

    $resetPasswordButton.on('click', function () {
      resetPassword();
    });

    /**
     * resetPassword send the request to reset the password
     * @returns {void}
     */
    var resetPassword = function () {
      $forgotPasswordForm.clearFormErrors();
      $forgotPasswordForm.updateCsrfToken();
      $formError.text('');

      $forgotPasswordForm.ajaxSubmit({
        dataType: 'json',

        success: function (data) {
          $resetPasswordButton.prop('disabled', false);
          $forgotPasswordForm.updateCsrfToken();
          if (data.success) {
            confirmation(null, data.message, null, 0);
            return;
          }

          $forgotPasswordForm.fieldErrors(data.fieldErrors);

          if (!data.fieldErrors) {
            $formError.text(data.message || genericErrorMessage);
          }
        },

        error: function () {
          $forgotPasswordForm.updateCsrfToken();
          $formError.text(genericErrorMessage);
          $resetPasswordButton.prop('disabled', false);
        }
      });
    };

    $forgotPasswordForm.on('submit', function (e) {
      e.preventDefault();
      resetPassword();
    });

    $resetPasswordButton.on('click', function () {
      $resetPasswordButton.prop('disabled', true);
    });
  };

  init();

  return api;
})();
